import React from "react";
import './GuestBook.css';
import { MDBContainer, MDBCard, MDBCardBody } from "mdb-react-ui-kit";
import translations from "../../data/translations";
import Modal from "../../components/modal/Modal";
import GuestBookForm from "../../components/form/Form";
import MessageList from "../../components/message/MessageList";

function GuestBookPage() {
  const [name, setName] = React.useState("");
  const [country, setCountry] = React.useState(null);
  const [city, setCity] = React.useState(null);
  const [message, setMessage] = React.useState("");
  const [language, setLanguage] = React.useState("english");
  const [errors, setErrors] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [modalMessage, setModalMessage] = React.useState("");
  const [messages, setMessages] = React.useState([]);

  // Fetch messages on mount
  React.useEffect(() => {
    fetchMessages();
  }, []);

  function fetchMessages() {
    fetch(
      "https://e03nc8puh0.execute-api.eu-west-3.amazonaws.com/prod/messages"
    )
      .then((res) => res.json())
      .then((data) => setMessages(data.reverse()))
      .catch(() => setMessages([]));
  }

  function validate() {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required";
    if (!country || !country.value || !country.value.trim())
      newErrors.country = "Country is required";
    if (!message.trim()) newErrors.message = "Message is required";
    if (message.length > 1000)
      newErrors.message = "Message must be under 1000 characters";
    return newErrors;
  }

  async function sendMessage(name, country, city, message) {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    setLoading(true);
    try {
      const response = await fetch(
        "https://e03nc8puh0.execute-api.eu-west-3.amazonaws.com/prod/entry",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name,
            country: country?.value,
            city: city?.value,
            message,
          }),
        }
      );
      setLoading(false);
      if (response.status === 200) {
        setName("");
        setCountry(null);
        setCity(null);
        setMessage("");
        setModalMessage(translations[language].sent);
        setModalOpen(true);
        fetchMessages();
      } else {
        setModalMessage(translations[language].failed);
        setModalOpen(true);
      }
    } catch (error) {
      setLoading(false);
      setModalMessage(translations[language].failed);
      setModalOpen(true);
    }
  }

  return (
    <div>
      <MDBContainer fluid className="p-0">
        {/* Header */}
        <div
          className="p-5 bg-image"
          style={{
            background: "linear-gradient(135deg, #b7d3e6 0%, #76a4bb 100%)",
            height: "200px",
          }}
        ></div>

        {/* Form Card */}
        <MDBCard
          className="mx-auto mb-5 p-3 p-md-5 shadow-5 guestbook-card"
          style={{
            maxWidth: "500px",
            marginTop: "-100px",
            background: "hsla(0, 0%, 100%, 0.8)",
            backdropFilter: "blur(30px)",
            borderRadius: "18px",
          }}
        >
          <MDBCardBody className="p-3 p-md-5 text-center">
            <img
              src="https://minas-guest-book.s3.eu-west-3.amazonaws.com/images/Dollhouse+logo+grey+3.svg"
              className="img-thumbnail guestbook-logo"
              alt="logo"
              style={{
                maxWidth: "200px",
                height: "auto",
                borderRadius: "12px",
              }}
            />
            <h2 className="fw-bold mb-4 mt-3" style={{ fontSize: "1.3rem" }}>
              {translations[language].title}
            </h2>
            <GuestBookForm
              name={name}
              setName={setName}
              country={country}
              setCountry={setCountry}
              city={city}
              setCity={setCity}
              message={message}
              setMessage={setMessage}
              language={language}
              setLanguage={setLanguage}
              errors={errors}
              loading={loading}
              sendMessage={sendMessage}
            />
          </MDBCardBody>
        </MDBCard>

        {/* Message List */}
        <MessageList messages={messages} />
      </MDBContainer>

      {/* Modal */}
      <Modal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalMessage={modalMessage}
        language={language}
      />
    </div>
  );
}

export default GuestBookPage;
